import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import { connect } from "react-redux";

import { icons } from "constants/icons";
import { Can } from "constants/abilityContext";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  datePickerProps,
  selectProps,
  dateFormat,
  displayErrorContext,
  renderProjectSelectOption,
} from "utils";

import { Header } from "components";
import { Icon, Input, notification, Button, Radio, Select, DatePicker, Spin } from "antd";

import { incidentService, projectService, userService, selectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class IncidentPage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      incident: {
        __type: "Incident",
        id: id,
        accident: 0,
      },
      uploading: false,
      errors: {},
      edited: false,
      risks: [],
      projects: [],
      users: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { incident } = this.state;
    const { edit, create } = this.props;

    if (!create) {
      incidentService
        .get(incident.id)
        .then((result) => {
          if (edit) result.users = result.users.map((u) => u.id);
          if (edit) result.risks = result.risks.map((r) => r.id);
          this.setState({ incident: { ...incident, ...result } });
        })
        .catch((e) => {
          history.push("/incidents");
        });
    }

    if (edit || create) this.fetchSelects();
  }

  componentWillReceiveProps(nextProps) {
    const { types } = this.state;
    const { edit, create } = nextProps;
    if ((!types || types.length === 0) && (edit || create)) this.fetchSelects();
  }

  async fetchSelects() {
    const selects = await selectService.listForPage("incident");
    const projects = await projectService.list({
      order_by: "code,label",
      order_direction: "ASC,ASC",
      disabled: 0,
    });
    const users = await userService.list();

    this.setState({ risks: selects.Risk, users, projects });
  }

  formatTag(key, fixed = false, label = "") {
    const { incident, errors } = this.state;
    const { edit, create } = this.props;

    if ((!edit && !create) || (fixed && edit)) {
      switch (key) {
        case "project_id":
          return incident.project ? (
            <Link to={`/projects/${incident.project_id}`}>
              <Icon type={icons.project} />
              {`${incident.project.code}: ${incident.project.label}`}
            </Link>
          ) : (
            ""
          );
        case "accident":
          const accidentMap = { 0: "Incident", 1: "Accident", 2: "Near Miss" };
          const current = accidentMap[incident[key]] || "";
          return (
            <li className={`alt ${current.toLowerCase().replace(" ", "")}`}>
              <Icon type="bell" />
              {current}
            </li>
          );
        case "risks":
          return (
            <b>
              {(incident[key] || []).map((r) => (
                <i key={r.id} className="list-item">
                  {r.label}
                </i>
              ))}
            </b>
          );
        case "users":
          return (
            <b>
              {(incident[key] || []).map((u) => (
                <i key={u.id} className="list-item">
                  {u.name + " " + u.surname}
                </i>
              ))}
            </b>
          );
        case "date":
          return (
            <>
              <Icon type="calendar" />
              {incident[key] ? moment(incident[key]).format(dateFormat) : null}
            </>
          );
        default:
          return <b>{incident[key]}</b>;
      }
    }

    var input;
    if (key === "accident") {
      input = (
        <Radio.Group
          name={key}
          onChange={(e) => this.handleChange(e.target.value, key)}
          value={incident[key]}
        >
          <Radio.Button value={0}>Incident</Radio.Button>
          <Radio.Button value={1}>Accident</Radio.Button>
          <Radio.Button value={2}>Near Miss</Radio.Button>
        </Radio.Group>
      );
    } else if (key === "date") {
      input = (
        <DatePicker
          name={key}
          value={incident[key] ? moment(incident[key]) : null}
          onChange={(date, value) => this.handleChange(date, key)}
          {...datePickerProps()}
        />
      );
    } else if (key === "project_id" || key === "risks" || key === "users") {
      var list = [],
        computeLabel = (t) => t.label;
      if (key === "project_id") {
        list = this.state.projects;
        computeLabel = renderProjectSelectOption;
      }
      if (key === "risks") {
        list = this.state.risks;
        computeLabel = (t) => t.label;
      }
      if (key === "users") {
        list = this.state.users;
        computeLabel = (t) => t.name + " " + t.surname;
      }

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          mode={key === "users" || key === "risks" ? "multiple" : "default"}
          value={incident[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else {
      var Tag = key === "details" ? Input.TextArea : Input;

      input = (
        <Tag
          name={key}
          value={incident[key]}
          autoSize={{ minRows: 3, maxRows: 20 }}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({
      incident: { ...this.state.incident, [key]: value },
      edited: true,
    });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var incident = { ...this.state.incident };
    const { edit, create } = this.props;

    var func;

    if (edit) {
      func = incidentService.update;
    } else if (create) {
      func = incidentService.create;
      incident.user_id = this.props.userId;
    }

    this.setState({ uploading: true }, () => {
      func(incident)
        .then((n) => {
          notification.open({
            message: "Enregistrement effectué",
            description: "Vos changements ont été enregistrés avec succès.",
            placement: "bottomRight",
          });

          this.setState({
            incident: { ...incident, ...n },
            edited: false,
            uploading: false,
          });
          history.replace(`/incidents/${n.id}`);
        })
        .catch((e) => {
          this.setState({ uploading: false });
          notification.open({
            message: "Une erreur s'est produite",
            description: "Veuillez réessayer ou contacter un administrateur.",
            placement: "bottomRight",
          });
        });
    });
  }

  validateFields() {
    const { incident } = this.state;
    const { edit, create } = this.props;

    var fields = ["project_id", "users", "date"];
    var validation = validateProfileFields(incident, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { incident, errors, uploading } = this.state;
    const { edit, create } = this.props;

    var mode = "read",
      pageTitle = "Détails d'un incident",
      header = `Incident #${incident.id}`,
      bread = [{ to: "/incidents", text: "Liste des incidents" }, { text: incident.id }];

    if (edit) {
      mode = "edit";
      pageTitle = "Édition d'un incident";
      bread = [
        { to: "/incidents", text: "Liste des incidents" },
        { to: `/incidents/${incident.id}`, text: incident.id },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = "Création d'un incident";
      header = "Nouvel incident";
      bread = [{ to: "/incidents", text: "Liste des incidents" }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`incident-page main-content profile-content ${mode}`}>
          <Can do={mode} on={incident}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              {mode === "read" && (
                <ul className="tags">
                  <li>{this.formatTag("project_id")}</li>
                  {this.formatTag("accident")}
                  <li className="alt">{this.formatTag("date")}</li>
                </ul>
              )}

              <ul className={"profile-main-content " + mode}>
                {mode !== "read" && (
                  <li style={{ marginBottom: "30px" }}>{this.formatTag("accident", false)}</li>
                )}

                {mode !== "read" && (
                  <li>
                    <label>Projet :</label>
                    {this.formatTag("project_id")}
                  </li>
                )}

                <li>
                  <label>Utilisateurs impliqués :</label>
                  {this.formatTag("users")}
                </li>

                <li>
                  <label>Risques impliqués :</label>
                  {this.formatTag("risks")}
                </li>

                {mode !== "read" && (
                  <li>
                    <label>Date :</label>
                    {this.formatTag("date")}
                  </li>
                )}

                <li>
                  <label>Détails :</label>
                  {this.formatTag("details")}
                </li>
              </ul>

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : "Créer l'incident"}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button
                    type="primary"
                    onClick={() => history.push("/incidents/" + incident.id + "/edit")}
                  >
                    Éditer cet incident
                  </Button>
                </div>
              )}
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.infos.id,
  };
};

export default connect(mapStateToProps, null)(IncidentPage);
